import FormsTable from './FormsTable';

export default FormsTable;
